import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

import { UserRoutingModule } from './user-routing.module';
import { UserLoginComponent } from './login/user-login/user-login.component';
import { UserLoggedInComponent } from './login/user-logged-in/user-logged-in.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    UserRoutingModule,
    UserLoggedInComponent,
  ],
  declarations: [
    UserLoginComponent,
  ]
})
export class UserModule { }
